export default "__VITE_ASSET__wWTdWERo__"